(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["skb-logo-bar"] && !Shopify.designMode) return;
  try {
    
$(function() {
    var header = $(".skb_logo_bar_section");
  
    $(window).scroll(function() {    
        var scroll = $(window).scrollTop();
        if (scroll >= 50) {
            header.addClass("scrolled");
        } else {
            header.removeClass("scrolled");
        }
    });
  
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skb-top-promo-bar-mobile"] && !Shopify.designMode) return;
  try {
    
$(function() {
    var header = $(".skb_top_promo_slid");
  
    $(window).scroll(function() {    
        var scroll = $(window).scrollTop();
        if (scroll >= 50) {
            header.addClass("scrolled");
        } else {
            header.removeClass("scrolled");
        }
    });
  
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skb-top-promo-bar"] && !Shopify.designMode) return;
  try {
    
$(function() {
    var header = $(".skb_top_promo_slid");
  
    $(window).scroll(function() {    
        var scroll = $(window).scrollTop();
        if (scroll >= 50) {
            header.addClass("scrolled");
        } else {
            header.removeClass("scrolled");
        }
    });
  
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skb_product_sticky_cart"] && !Shopify.designMode) return;
  try {
    
$(function() {
    var header = $(".skbps_cart_class");
  
    $(window).scroll(function() {    
        var scroll = $(window).scrollTop();
        if (scroll >= 750) {
            header.addClass("scrolled");
        } else {
            header.removeClass("scrolled");
        }
    });
  
});

  } catch(e) { console.error(e); }
})();
})();
